import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontFamily } from '../../../constants/text';
import PropTypes from 'prop-types';

const Root = styled.div`
  height: 14px;
  width: 241px;
  color: ${colors.squid};
  font-family: ${fontFamily.bold};
  font-size: 24px;
  line-height: 14px;
  text-align: center;
  margin: 0 auto;
`;

class Title extends PureComponent {
  render() {
    const { className } = this.props;
    return <Root className={className}>{this.props.children}</Root>;
  }
}

Title.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export default Title;
